app.directive('programEditorExerciseListTile', function ($log) {
    return {
        restrict: 'A',
        scope: {
            model: '=programEditorExerciseListTile',
            weekIndex: '=weekIndex',
            dayIndex: '=dayIndex',
            tileIndex: '=tileIndex'
        },
        transclude: true,
        terminal: true,
        link: function ($scope, $element, $attrs, $ctrls, $transclude) {
            $transclude($scope.$new(true), function (clone, childScope) {
                $element.append(clone);

                childScope.programEditorExerciseListTile = {};

                $scope.$watch('model', function (newValue) {
                    if (!angular.isObject(newValue)) {
                        // noinspection JSValidateTypes
                        newValue = {'mode': 'one_exercise', 'exercises': [], 'text': null, 'timeMin': null, 'timeSec': null};
                    }

                    if (!angular.isArray(newValue.exercises)) {
                        newValue.exercises = [];
                    }

                    childScope.programEditorExerciseListTile.model = newValue;
                });

                $scope.$watch('weekIndex', function (newValue) {
                    childScope.programEditorExerciseListTile.weekIndex = newValue;
                });

                $scope.$watch('dayIndex', function (newValue) {
                    childScope.programEditorExerciseListTile.dayIndex = newValue;
                });

                $scope.$watch('tileIndex', function (newValue) {
                    childScope.programEditorExerciseListTile.tileIndex = newValue;
                });

                childScope.$watch('programEditorExerciseListTile.model.mode', function (newValue) {
                    switch (newValue) {
                        case 'one_exercise':
                        case 'one_exercise_text':
                        case 'superset':
                        case 'stretching':
                        case 'text':
                            return;
                    }

                    // Safeguard against invalid mode
                    childScope.programEditorExerciseListTile.model.mode = 'text';
                });

                childScope.programEditorExerciseListTile.setMode = function ($event, mode) {
                    $event.preventDefault();
                    childScope.programEditorExerciseListTile.model.mode = mode;
                };

                childScope.programEditorExerciseListTile.removeTile = function ($event) {
                    $event.preventDefault();
                    childScope.$emit('programEditorExerciseListTile.requestDelete', childScope.programEditorExerciseListTile.tileIndex);
                };

                childScope.programEditorExerciseListTile.removeExercise = function ($event, index) {
                    $event.preventDefault();
                    childScope.programEditorExerciseListTile.model.exercises[index].id = null;
                    childScope.programEditorExerciseListTile.model.exercises[index].name = null;
                    childScope.programEditorExerciseListTile.model.exercises[index].media = null;
                };

                childScope.programEditorExerciseListTile.onDropExerciseMedia = function ($event, model, index) {
                    if (model.draggable.is('[data-exercise-info]')) {
                        var exerciseInfo = JSON.parse(model.draggable.attr('data-exercise-info'));

                        if (!childScope.programEditorExerciseListTile.model.exercises[index]) {
                            childScope.programEditorExerciseListTile.model.exercises[index] = exerciseInfo;
                        } else {
                            childScope.programEditorExerciseListTile.model.exercises[index].id = exerciseInfo.id;
                            childScope.programEditorExerciseListTile.model.exercises[index].name = exerciseInfo.name;
                            childScope.programEditorExerciseListTile.model.exercises[index].media = exerciseInfo.media;
                        }
                    }
                };

                childScope.programEditorExerciseListTile.onDropReorderNotify = function ($event, model) {
                    if (model.draggable.is('.sg-pe-list-tile-form')) {
                        var draggableIndexText = model.draggable.find('.sg-pe-list-tile-index').text();

                        if (typeof draggableIndexText !== 'string' || draggableIndexText === '') {
                            return;
                        }

                        var oldIndex = parseInt(draggableIndexText, 10) - 1;

                        childScope.$emit('programEditorExerciseListTile.requestMove', oldIndex, childScope.programEditorExerciseListTile.tileIndex);
                    }
                };
            });
        }
    };
});
